"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _useAuthContext = _interopRequireDefault(require("./useAuthContext"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/*
 * Copyright (c) 2022, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

/**
 * @group Shopper Authentication helpers
 */

/**
 * Hook that returns the usid associated with the current access token.
 *
 * @group Helpers
 * @category Shopper Authentication
 */
const useUsid = () => {
  const auth = (0, _useAuthContext.default)();

  // TODO: auth.get does not trigger a re-render.
  // This is fine for now since the only time the usid changes is on logout
  // and currently when we log out we redirect to the login page which
  // causes components to unmount.
  // This will need to change if we stay on the PDP after logout
  const usid = auth.get('usid');
  const getUsidWhenReady = () => auth.ready().then(({
    usid
  }) => usid);
  return {
    usid,
    getUsidWhenReady
  };
};
var _default = exports.default = useUsid;